import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Numbers } from 'src/app/utils/constants';

export default class HomeUtilsComponent {

  /**
   * @description fill Insured Data
   */
  fillInsuredData(fb: FormBuilder): FormGroup {
    return fb.group({
      typeOwner: 'Particular',
      particular: fb.group({
        name: ['', { updateOn: 'change' }]
      }),
      bussines: fb.group({
        companySector: ['', { updateOn: 'change' }],
        direction: ['', { updateOn: 'change' }]
      }),
      documentType: ['', { updateOn: 'change' }],
      documentNumber: ['', { updateOn: 'change' }],
      firstSurname: '',
      secondSurname: '',
      email: ['', { updateOn: 'change' }],
      prefix: ['', { updateOn: 'change' }],
      telephone: ['', { updateOn: 'change' }],
      direction: ['', { updateOn: 'change' }],
      postalCode: ['', { updateOn: 'change' }],
      municipality: ['', { updateOn: 'change' }],
      province: ['', { updateOn: 'change' }],
      provinceId: 0,
      country: ['', { updateOn: 'change' }],
      sendAdvertisingInternationalSOS: null
    });
  }

  /**
   * @description fill Emergency Contact
   */
  fillEmergencyContact(fb: FormBuilder): FormGroup {
    return fb.group({
      name: ['', { updateOn: 'change' }],
      firstSurname: ['', { updateOn: 'change' }],
      secondSurname: ['', { updateOn: 'change' }],
      prefix: ['', { updateOn: 'change' }],
      telephone: ['', { updateOn: 'change' }],
      relationWithInsured: ['', { updateOn: 'change' }],
      acceptTerms: [false, { updateOn: 'change' }],
      adequacyOfProduct: [false, { updateOn: 'change' }],
      treatmentOfData: null,
      // sendAdvertisingInternationalSOS: null,
      sendAdvertisingByThirdParties: null,
      sendAdvertisingEventsAndNews: true
    });
  }

  /**
   * @description fill Insured List Data
   */
  fillInsuredListData(fb: FormBuilder): FormArray {
    return fb.array([
      fb.group({
        documentType: ['', { updateOn: 'change' }],
        documentNumber: ['', { updateOn: 'change' }],
        name: ['', { updateOn: 'change' }],
        firstSurname: ['', { updateOn: 'change' }],
        secondSurname: '',
        dateBorn: '',
        email: ['', { updateOn: 'change' }],
        prima: 0
      })
    ]);
  }

  /**
   * @description fill Guarantee Selection
   */
  fillGuaranteeSelection(fb: FormBuilder): FormGroup {
    return fb.group({
      deathAndDisability: '',
      tripCancellation: '',
      lostOrStolenLuggage: '',
      vacationRefund: ''
    });
  }

  /**
   * @description fill Terms List
   */
  fillTermsList(): { Aceptacion: string, Id_Tipo_Consentimiento: string }[][] {
    return [[
      { Aceptacion: '0', Id_Tipo_Consentimiento: '1' },
      { Aceptacion: '0', Id_Tipo_Consentimiento: '9' },
      { Aceptacion: '0', Id_Tipo_Consentimiento: '15' },
      { Aceptacion: '0', Id_Tipo_Consentimiento: '16' }
    ]];
  }

  /**
   * @description fill Incoming Students Travel Assistance
   */
  fillIncomingStudentsTravelAsistance(fb: FormBuilder): FormGroup {
    return fb.group({
      insuranceTypeList: [[]],  // prop de apoyo se rellena con un array de opciones
      numberOfInsuredList: [[]],  // prop de apoyo se rellena con un array de opciones
      yearsList: [[]],  // prop de apoyo se rellena con un array de opciones
      sportList: [[]],  // prop de apoyo se rellena con un array de opciones
      sectorList: [[]],  // prop de apoyo se rellena con un array de opciones
      typeStudent: '',  // prop de apoyo, se rellena con el tipo de estudiante (incoming / outgoing / nacional)
      guaranteeIncoming: [[]],  // prop de apoyo se rellena con un array de opciones
      guaranteeOutgoing: [[]],  // prop de apoyo se rellena con un array de opciones
      guaranteeNational: [[]],  // prop de apoyo se rellena con un array de opciones
      idCorreduria: '', // prop de apoyo se rellena con el valor de id correduría
      logoCorreduria: '', // prop de apoyo se rellena con el valor de url logo correduría
      numberOfInsured: ['', { updateOn: 'change' }],
      guaranteeLimitOfMedicalExpenses: ['', { updateOn: 'change' }],
      insuredOlderThan60years: '0',
      insuredsPlayRiskSports: '',
      allInsuredSameFamiliarUnit: [null, { updateOn: 'change' }],
      insuranceDuration: '', // Temporalidad paso 1
      countryOrigin: [[], { updateOn: 'change' }],
      countryDestiny: [[], { updateOn: 'change' }],
      countryDestinyI: ['', { updateOn: 'change' }],
      countryOriginEnvironment: '',
      countryDestinyEnvironment: '',
      dateStart: ['', { updateOn: 'change' }],
      dateEnd: ['', { updateOn: 'change' }],
      insuranceTime: '', // Radio paso 1 Temporal, anual
      insuranceTimeDays: 0,
      currentlyTraveling: null,
      codePromotional: '',
      hasCodeDerogation: null,
      derogationCodes: [[]],
      insuranceType: '', // Temporalidad paso 2
      insuredData: this.fillInsuredData(fb),
      emergencyContact: this.fillEmergencyContact(fb),
      insuredListData: this.fillInsuredListData(fb),
      guaranteeSelection: this.fillGuaranteeSelection(fb),
      guaranteeSelectionList: [[]],
      termsList: this.fillTermsList()
    });
  }

  /**
   * @description iniciar asitente viaje particular
   */
  particularTravelAsistanceUtils(fb: FormBuilder): FormGroup {
    return fb.group({
      insuranceTypeList: [[]],  // prop de apoyo se rellena con un array de opciones
      numberOfInsuredList: [[]],  // prop de apoyo se rellena con un array de opciones
      yearsList: [[]],  // prop de apoyo se rellena con un array de opciones
      sportList: [[]],  // prop de apoyo se rellena con un array de opciones
      sectorList: [[]],  // prop de apoyo se rellena con un array de opciones
      idCorreduria: '', // prop de apoyo se rellena con el valor de id correduría
      logoCorreduria: '', // prop de apoyo se rellena con el valor de url logo correduría
      numberOfInsured: ['', { updateOn: 'change' }],
      guaranteeLimitOfMedicalExpenses: ['', { updateOn: 'change' }],
      insuredOlderThan70years: '',
      insuredsPlayRiskSports: '',
      allInsuredSameFamiliarUnit: [null, { updateOn: 'change' }],
      insuranceDuration: '', // Temporalidad paso 1
      countryOrigin: [[], { updateOn: 'change' }],
      countryDestiny: [[], { updateOn: 'change' }],
      countryOriginEnvironment: '',
      countryDestinyEnvironment: '',
      dateStart: ['', { updateOn: 'change' }],
      dateEnd: ['', { updateOn: 'change' }],
      insuranceTime: '', // Radio paso 1 Temporal, anual
      currentlyTraveling: null,
      petInsureds: '',
      hasPetsInsurance: null,
      codePromotional: '',
      hasCodeDerogation: null,
      derogationCodes: [[]],
      insuranceType: '', // Temporalidad paso 2
      insuredData: this.fillInsuredData(fb),
      emergencyContact: fb.group({
        name: ['', { updateOn: 'change' }],
        firstSurname: ['', { updateOn: 'change' }],
        secondSurname: ['', { updateOn: 'change' }],
        prefix: ['', { updateOn: 'change' }],
        telephone: ['', { updateOn: 'change' }],
        relationWithInsured: ['', { updateOn: 'change' }],

        acceptTerms: [false, { updateOn: 'change' }],
        adequacyOfProduct: [false, { updateOn: 'change' }],

        treatmentOfData: null,
        // sendAdvertisingInternationalSOS: null,
        sendAdvertisingByThirdParties: null,
        sendAdvertisingEventsAndNews: true

      }),
      insuredListData: fb.array([
        fb.group({
          documentType: ['', { updateOn: 'change' }],
          documentNumber: ['', { updateOn: 'change' }],
          name: ['', { updateOn: 'change' }],
          firstSurname: ['', { updateOn: 'change' }],
          secondSurname: '',
          dateBorn: '',
          email: ['', { updateOn: 'change' }],
          prima: 0
        })
      ]),
      guaranteeSelection: fb.group({
        deathAndDisability: '',
        tripCancellation: '',
        lostOrStolenLuggage: '',
        vacationRefund: ''
      }),
      guaranteeSelectionList: [[]],
      termsList: [[
        { Aceptacion: '0', Id_Tipo_Consentimiento: '1' },
        { Aceptacion: '0', Id_Tipo_Consentimiento: '9' },
        { Aceptacion: '0', Id_Tipo_Consentimiento: '15' },
        { Aceptacion: '0', Id_Tipo_Consentimiento: '16' }
      ]]
    });
  }

  /**
   * @description iniciar asitente viaje particular
   */
  particularLegalAsistanceUtils(fb: FormBuilder): FormGroup {
    return fb.group({
      idCorreduria: '', // prop de apoyo se rellena con el valor de id correduría
      logoCorreduria: '', // prop de apoyo se rellena con el valor de url logo correduría
      numberOfInsured: 1,
      dateStart: ['', { updateOn: 'change' }],
      dateEnd: ['', { updateOn: 'change' }],
      insuranceTime: '', // Radio paso 1 Temporal, anual
      codePromotional: '',
      countryOriginEnvironment: Numbers.number19001,
      countryDestinyEnvironment: Numbers.number19001,
      insuranceDuration: 'Anual', // Temporalidad paso 1
      insuranceType: '', // Temporalidad paso 1 - radios
      insuredData: fb.group({
        documentType: ['', { updateOn: 'change' }],
        documentNumber: ['', { updateOn: 'change' }],
        name: ['', { updateOn: 'change' }],
        firstSurname: '',
        secondSurname: '',
        email: ['', { updateOn: 'change' }],
        prefix: ['', { updateOn: 'change' }],
        telephone: ['', { updateOn: 'change' }],
        direction: ['', { updateOn: 'change' }],
        postalCode: ['', { updateOn: 'change' }],
        municipality: ['', { updateOn: 'change' }],
        province: ['', { updateOn: 'change' }],
        provinceId: 0,
        country: ['', { updateOn: 'change' }],
        rentedHouse: [null, { updateOn: 'change' }],
        rentedHouseData: fb.group({
          direction: ['', { updateOn: 'change' }],
          postalCode: ['', { updateOn: 'change' }],
          municipality: ['', { updateOn: 'change' }],
          province: ['', { updateOn: 'change' }],
          provinceId: 0,
          country: ['', { updateOn: 'change' }]
        })
      }),
      domiciliation: fb.group({
        iban: ['', { updateOn: 'change' }],
        swift: ['', { updateOn: 'change' }],
        acceptTerms: [null, { updateOn: 'change' }],
        adequacyOfProduct: [false, { updateOn: 'change' }],
        treatmentOfData: null,
        sendAdvertisingInternationalSOS: null,
        sendAdvertisingByThirdParties: null,
        sendAdvertisingEventsAndNews: null
      }),
      guaranteeSelection: fb.group({
        deathAndDisability: '',
        tripCancellation: '',
        lostOrStolenLuggage: '',
        vacationRefund: ''
      }),
      guaranteeSelectionList: [[]],
      termsList: [[

        { Aceptacion: '0', Id_Tipo_Consentimiento: '1' },
        { Aceptacion: '0', Id_Tipo_Consentimiento: '9' },
        { Aceptacion: '0', Id_Tipo_Consentimiento: '15' },
        { Aceptacion: '0', Id_Tipo_Consentimiento: '16' }

      ]]
    });
  }
}
